import React, { useEffect, useState } from "react";
import CommonList from "../crud/CommonList";
import { apiCall, apiCallResponse } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import { FilterContainsInsensitive } from "../common/FilterCondition";
import {
  CommonSearch,
  SCAddButton,
  SCInput,
  updateSearchStatus,
} from "../common/CommonSearch";

const TenderList = () => {
  const { authenticated } = Auth();
  const [usersData, setuserData] = useState([]); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [textField, settextField] = useState("tenderNo"); // table header Default Selected Column
  const [order, setorder] = useState("asc"); // table header Default Selected Column order Set
  const [orderClick, setOrderClick] = useState(true); // table header orderClick Column manage

  const [disabledApproveRej, setdisabledApproveRej] = useState(false);

  // Your default search model
  const SearchFilterModel = {
    collectionSeason:  new Date().getFullYear().toString(),
    tenderNo: "",
    details: "",
  };

  const [search, setSearch] = useState(SearchFilterModel); // Search Manage

  useEffect(() => {
    setloading(true);
    resetPageLimit();
    if (authenticated.role === "CGMF" && authenticated.isViewOnly) {
      setdisabledApproveRej(true);
    } else {
      setdisabledApproveRej(false);
    }
    getPageCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getTenderList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, itemPerPage, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getTenderList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  //Pagging Disabled /Enable manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  //Pagging manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";

    filter = "&$filter=";
    filter = FilterContainsInsensitive(
      filter,
      "collectionSeason",
      search.collectionSeason
    );

    filter = FilterContainsInsensitive(filter, "tenderNo", search.tenderNo);
    filter = FilterContainsInsensitive(filter, "details", search.details);

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };

  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(`Tender?${filterManage()}`).then((res) => {
        if (res.success) paggingManage(parseInt(res.data.length) || 0);
      });
    }
  };
  const getTenderList = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `Tender?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`
      )
        .then((res) => {
          if (res.success) {
            setuserData(res.data);
            if (pageLimit > -1 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else {
            setuserData([]);
            paggingManage(0, false);
          }
          setloading(false);
        })
        .finally();
    }
  };

  const generateLetter = async (tenderId, startNo, date) => {
    const header = new Headers();
    const response = await apiCall(
      `Tender/GenerateSanctionLetter?TenderId=${tenderId}&startNumber=${startNo}&Date=${date}`,
      "GET",
      header,
      null
    );

    await response.json();
    if (response.status === 200) {
      alert("Sancttion Letter Genetared");
      getTenderList();
    }
  };

  const generateAgreementLetter = async (tenderId, date) => {
    const header = new Headers();
    const response = await apiCall(
      `Tender/GenerateAgreementLetterLotWise?TenderId=${tenderId}&Date=${date}`,
      "GET",
      header,
      null
    );

    await response.json();
    if (response.status === 200) {
      alert("Agreement Letter Genetared");
      getTenderList(true);
    }
  };

  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };

  //table header Click manage
  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    resetPageLimit();
    settextField(getTextField);
  };

  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  let fields = [];
  if (authenticated.role === "CGMF") {
    fields = [
      {
        key: "tenderNo",
        label: TableHeaderSet("Tender Number", "tenderNo"),
      },
      {
        key: "details",
        _style: { width: "15%" },
        label: TableHeaderSet("Details", "details"),
      },
      {
        key: "paymentSlots",
        label: TableHeaderSet("Payment Slots", "paymentSlots"),
      },
      {
        key: "rebate",
        label: TableHeaderSet("Rebate", "rebate"),
      },
      {
        key: "dateFormat",
        label: TableHeaderSet("Purchase Date", "purchaseDate"),
      },
      {
        key: "lateFeePerDay",
        label: TableHeaderSet("Late Fee Per Day", "lateFeePerDay"),
      },
      {
        key: "CollectionSession",
        label: TableHeaderSet("Collection Season", "collectionSeason"),
      },
      {
        key: "LeasePDate",
        label: TableHeaderSet("Lease Period Date", "leasePeriodDate"),
      },

      {
        key: "ConditionalBtn",
        label: "Edit",
        sorter: false,
        filter: false,
      },
      {
        key: "ViewTenderBtn",
        label: "View",
        sorter: false,
        filter: false,
      },
      {
        key: "GenerateLetter",
        _style: { width: "10%" },
        label: "Generate Sanction Letter",
        sorter: false,
        filter: false,
      },
      {
        key: "AgreementLetter",
        _style: { width: "10%" },
        label: "Generate Agreement Letter",
        sorter: false,
        filter: false,
      },
      {
        key: "viewcirclereport",
        _style: { width: "10%" },
        label: "View Circle Report",
        sorter: false,
        filter: false,
      },
    ];
  } else {
    fields = [
      {
        key: "tenderNo",
        label: TableHeaderSet("Tender Number", "tenderNo"),
      },
      {
        key: "details",
        _style: { width: "15%" },
        label: TableHeaderSet("Details", "details"),
      },
      {
        key: "paymentSlots",
        label: TableHeaderSet("Payment Slots", "paymentSlots"),
      },
      {
        key: "rebate",
        label: TableHeaderSet("Rebate", "rebate"),
      },
      {
        key: "dateFormat",
        label: TableHeaderSet("Purchase Date", "purchaseDate"),
      },
      {
        key: "lateFeePerDay",
        label: TableHeaderSet("Late Fee Per Day", "lateFeePerDay"),
      },
      {
        key: "CollectionSession",
        label: TableHeaderSet("Collection Season", "collectionSeason"),
      },
      {
        key: "LeasePDate",
        label: TableHeaderSet("Lease Period Date", "leasePeriodDate"),
      },

      {
        key: "ConditionalBtn",
        label: "Edit",
        sorter: false,
        filter: false,
      },

      {
        key: "ViewTenderBtn",
        label: "View",
        sorter: false,
        filter: false,
      },
      {
        key: "viewcirclereport",
        _style: { width: "10%" },
        label: "View Circle Report",
        sorter: false,
        filter: false,
      },
    ];
  }
  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
    paggingManage(pageCount);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setuserData([]);
  };
  //

  let additional = (
    <CommonSearch
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isCompanyNameDisplay={false}
      extraControl={
        <SCInput
          label={"Details : "}
          name={"details"}
          value={search.details}
          onChange={updateSearch}
        />
      }
      extraSearchControl={<SCAddButton tourl={"/addtender"} />}
    />
  );

  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Tender List"
      loading={loading}
      path={`/edittender/`}
      tabBtn="Edit"
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      additional={additional}
      id="tenderId"
      agreementid="tenderId"
      seccpath="/senctionLetter/"
      generateBtn={generateLetter}
      generateAgreement={generateAgreementLetter}
      disableApproveReject={disabledApproveRej}
    />
  );
};
export default TenderList;
